import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unidad-medida-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  tamano = document.body.clientHeight;
}